// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


import flexble from './assets/js/flexble.js'
import notice from './assets/js/notice.js'
import VueQriously from 'vue-qriously'
import fetch from './fetch/fetch'


import MintUI from 'mint-ui'


import 'mint-ui/lib/style.css'
import './assets/stylesheet/iconfont.css'
import './assets/iconfont/iconfont.css'


//{url:`${encodeURIComponent(location.href.split('#')[0])}`}
// http.getWechatSignatures().then(res => {
//   console.log(res)
//   console.log('res.data:', res.data)
//   wx.config({
//     debug:false,
//     appId:res.data.appId,
//     timestamp:res.data.timestamp,
//     nonceStr:res.data.nonceStr,
//     signature:res.data.signature,
//     jsApiList:[
//       'checkJsApi','scanQRCode',
//     ]
//   })
// })
// wx.ready(function() {
//   wx.checkJsApi({
//     jsApiList : ['scanQRCode'],
//     success : function(res) {
//       console.log(res)
//     }
//   });

// });






Vue.use(MintUI)

Vue.config.productionTip = false
Vue.prototype.$http = fetch


Vue.prototype.$notice = notice
const Bus = new Vue()
Vue.use(VueQriously)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  data:{Bus},
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js